// src/services/driverService.js
import { API_BASE_URL } from "./apiConfig";
import { logApiContext } from "../config/apiBaseUrl";

const API_URL = `${API_BASE_URL}/api/drivers`;
const logRequest = (action, url) =>
  logApiContext(`driverService:${action}`, { url, API_URL });

export const getDriversByBoss = async () => {
  const token = localStorage.getItem("token");
  const url = `${API_URL}/by-boss`;
  logRequest("getDriversByBoss", url);
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const text = await response.text();
    console.error("Error getDriversByBoss response", {
      status: response.status,
      statusText: response.statusText,
      body: text,
    });
    throw new Error(text || "Error al obtener conductores");
  }

  return await response.json(); // será un array de drivers
};

export const getDriverById = async (id) => {
  const token = localStorage.getItem("token");
  const url = `${API_URL}/${id}`;
  logRequest("getDriverById", url);
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const text = await response.text();
    console.error("Error getDriverById response", {
      status: response.status,
      statusText: response.statusText,
      body: text,
    });
    throw new Error(text || "Error al obtener conductor");
  }

  return await response.json();
};

export const updateDriver = async (id, payload) => {
  const token = localStorage.getItem("token");
  const url = `${API_URL}/${id}`;
  logRequest("updateDriver", url);
  const response = await fetch(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const text = await response.text();
    console.error("Error updateDriver response", {
      status: response.status,
      statusText: response.statusText,
      body: text,
    });
    throw new Error(text || "Error al actualizar conductor");
  }

  return await response.json();
};
